// extracted by mini-css-extract-plugin
export default {"LogoIcon":"LogoIcon_LogoIcon__YfMEj"};